import React, { useState } from 'react';
import LogoIcon from '../../svg/LogoIcon';
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { AnchorLink } from "gatsby-plugin-anchor-links";

function Header({siteTitle}) {
  const [isExpanded, toggleExpansion] = useState(false);
  const NavLinks = [
    {href: "/#features", name:"Inicio"},
    {href: "/#services", name:"¿Quiénes somos?"},
    {href: "/#stats", name:"Servicios"},
    {href: "/#testimonials", name:"Testimonios"},

  ];
  return (
    <header className="sticky top-0 bg-white shadow">
      <div className="container flex flex-col sm:flex-row justify-between items-center mx-auto py-4 px-8">
        <div className="flex items-center text-2xl">
          <div className="w-12 mr-3">
            <LogoIcon />
          </div>
          {siteTitle}
        </div>
        <div
          className={`${
            isExpanded ? `hidden` : `hidden`
          } sm:hidden md:hidden lg:block text-lg`}
        >
            {NavLinks &&
            NavLinks.map((node) => (
              <AnchorLink
                to={node.href}
                className="block mt-4 hover:text-gray-400 text-slim text-white hover:text-black hover:no-underline md:inline-block md:mt-0 md:ml-6"
              >
                {node.name}
              </AnchorLink>
            ))}
          <Link
            to="/contact"
            className="px-4 py-2 ml-6 text-white rounded shadow-sm sm:relative sm:top-4 hover:no-underline bg-gray-600 hover:bg-primary-lighter"
          >
            <span className="">Contacto</span>
          </Link>
        </div>
        <div className="block lg:hidden">
          {/* beginning of hamburger */}
          <button
            onClick={() => toggleExpansion(!isExpanded)}
            className="flex items-center px-3 py-2  border border-white rounded text-white hover:text-teal-lighter hover:border-text-teal-lighter"
          >
            <svg
              className="w-3 h-3 fill-current"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Hamburger Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
          {/* beginning of small navbar */}
          <div
            className={`${
              isExpanded ? `block` : `hidden`
            } lg:hidden text-lg relative float-right inline-block text-left`}
          >
            <div className="absolute right-0 w-48 mt-2 origin-top-right rounded-md shadow-lg">
              <div className="bg-white rounded-md shadow-xs">
                <div
                  className="py-1"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu"
                >
                  {NavLinks &&
                  NavLinks.map((link) => (
                    <AnchorLink
                      className="block px-4 py-2 font-light leading-1 hover:text-secondary text-slim text-primary hover:text-black focus:bg-gray-100 focus:text-secondary hover:no-underline"
                      to={link.href}
                    >
                      {link.name}
                    </AnchorLink>
                  ))}
                  <Link
                    to="/contact"
                    className="px-4 mt-2 ml-6 text-white rounded  sm:top-4 hover:no-underline bg-gray-600 hover:bg-primary-lighter"
                  >
                    <span className="">Contacto</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
